module.exports = __webpack_public_path__ + "static/media/ASCBN-TITLE-SQUARE-LIGHT-TRANSPARENT.4b861af4.png";